import './style.css';
import { refundPayment } from "../../services/liferay/paymentRefund";

const PaymentPopup = ({ setPopup, formData, setHandleAlert, setCurrentRecords, setRefundFailed, translationMap }) => {
  const handleRequest = async () => {
    const sptrn = formData.sptrn;
    const servCode = formData.servCode;
    try {
      const refundResponse = await refundPayment(sptrn, servCode);
      if (refundResponse)
      {

      }
      setPopup(false);
      setHandleAlert(true);
      setCurrentRecords(refundResponse?.data);
    }
    catch (err) {
      setPopup(false);
      setRefundFailed(true);

      throw err;
    }
  };
  return (
    <>
            <div className="refund-modal">
                <div id="refundModal" className="modal-overlay" style={{ justifyContent: 'center', display: "flex" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{translationMap?.refund_confirmation || "Refund Confirmation"}</h3>
                        </div>
                        <div className="modal-body">
                            <h4 id="modalText">{translationMap?.confirm_continue || "Do you want to continue?"}</h4>
                            <div className="modal-buttons" id="confirmButtons">
                                <button onClick={handleRequest}>{translationMap?.yes_button || "Yes"}</button>
                                <button onClick={() => setPopup(false)}>{translationMap?.no_button || "No"}</button>
                            </div>
                            <div className="modal-buttons" id="closeButton">
                                <button onClick={() => setPopup(false)}>{translationMap?.close_button || "Close"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);

};

export default PaymentPopup;